/**
 * Recipe total time from saved list metadata (aligns with backend
 * recipe_search_filters.get_total_time_minutes / parse_time_to_minutes).
 */

export function parseRecipeTimeToMinutes(timeStr) {
  if (timeStr == null || timeStr === '') return null
  if (typeof timeStr === 'number' && !Number.isNaN(timeStr)) {
    return timeStr > 0 ? Math.round(timeStr) : null
  }
  const str = String(timeStr).trim()
  if (str.startsWith('PT')) {
    let total = 0
    const h = str.match(/(\d+)H/i)
    const m = str.match(/(\d+)M/i)
    if (h) total += parseInt(h[1], 10) * 60
    if (m) total += parseInt(m[1], 10)
    return total > 0 ? total : null
  }
  let totalMinutes = 0
  const hourMatch = str.match(/(\d+)\s*(?:h(?:our|ours)?|hr(?:s)?)\b/i)
  if (hourMatch) totalMinutes += parseInt(hourMatch[1], 10) * 60
  const minMatch = str.match(/(\d+)\s*m(?:in|inute|inutes)?\b/i)
  if (minMatch) totalMinutes += parseInt(minMatch[1], 10)
  if (totalMinutes === 0) {
    const num = str.match(/(\d+)/)
    if (!num) return null
    const n = parseInt(num[1], 10)
    const lower = str.toLowerCase()
    if (lower.includes('hour') || lower.includes('hr') || /\d+\s*h\b/.test(lower)) {
      return n * 60
    }
    return n > 0 ? n : null
  }
  return totalMinutes
}

export function getSavedListTotalMinutes(metadata) {
  if (!metadata || typeof metadata !== 'object') return null
  const totalTime = metadata.total_time ?? metadata.totalTime
  if (totalTime) {
    const m = parseRecipeTimeToMinutes(totalTime)
    if (m != null && m > 0) return m
  }
  const prep = metadata.prep_time ?? metadata.prepTime
  const cook = metadata.cook_time ?? metadata.cookTime
  const p = prep ? parseRecipeTimeToMinutes(prep) ?? 0 : 0
  const c = cook ? parseRecipeTimeToMinutes(cook) ?? 0 : 0
  const sum = p + c
  return sum > 0 ? sum : null
}

export function formatTotalTimeLabel(totalMinutes) {
  if (totalMinutes == null || totalMinutes <= 0) return null
  if (totalMinutes < 60) return `${totalMinutes} min`
  const h = Math.floor(totalMinutes / 60)
  const m = totalMinutes % 60
  if (m === 0) return h === 1 ? '1 hr' : `${h} hr`
  return `${h} hr ${m} min`
}

export function formatDurationMinutesLong(totalMinutes) {
  if (totalMinutes == null || totalMinutes <= 0) return null
  if (totalMinutes < 60) {
    return totalMinutes === 1 ? '1 minute' : `${totalMinutes} minutes`
  }
  const h = Math.floor(totalMinutes / 60)
  const m = totalMinutes % 60
  const hours = h === 1 ? '1 hour' : `${h} hours`
  if (m === 0) return hours
  const minutes = m === 1 ? '1 minute' : `${m} minutes`
  return `${hours} ${minutes}`
}
